/**
 * Auth headers for panel API calls: JWT Bearer when logged in.
 */
export function getAuthHeaders(extra = {}) {
  const headers = {
    ...extra,
  };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

/** Public (unauthenticated) pages — no client API key. */
export function getPublicApiHeaders(extra = {}) {
  return {
    ...extra,
  };
}

export async function apiFetch(url, options = {}) {
  const { headers: optionHeaders, ...rest } = options;
  return fetch(url, {
    ...rest,
    headers: {
      ...getAuthHeaders(),
      ...(optionHeaders || {}),
    },
  });
}

export default apiFetch;
